module.exports = __webpack_public_path__ + "img/Icono1-1.09714486.png";